/* Copyright © Bankers Healthcare Group, Inc.  All rights reserved. */

import Vue from 'vue';
import App from './views/App.vue';
import router from './router';
import '@bhgpdi/bhg-vue-components';
import '@bhgpdi/bhg-vue-components/dist/npm-vue-components.css';
import store from '@/store/index';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
